import { render, staticRenderFns } from "./ConsentListData.vue?vue&type=template&id=d546ffac&"
import script from "./ConsentListData.vue?vue&type=script&lang=js&"
export * from "./ConsentListData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports